module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/pdf-4d3fb938b2e808ee58b24f40633cf186.svg";